<template>
  <div class="job-wish-container">
    <div class="card-wrapper">
      <!-- 头部装饰 -->
      <div class="card-header">
        <div class="icon-box">
          <i class="el-icon-s-custom"></i>
        </div>
        <h2 class="title">求职意向登记</h2>
        <p class="subtitle">完善您的求职期望，让好工作更快找到您</p>
      </div>

      <!-- 表单区域 -->
      <el-form 
        ref="wishForm" 
        :model="form" 
        :rules="rules" 
        label-position="top" 
        class="wish-form"
      >
        
        <!-- 第一行：期望岗位 & 期望地区 -->
        <div class="form-row">
          <el-form-item label="期望岗位" prop="wantGangwei">
            <el-input 
              v-model="form.wantGangwei" 
              placeholder="例如：Java开发工程师、产品经理" 
              prefix-icon="el-icon-briefcase"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="期望工作地区" prop="wantAddress">
            <el-input 
              v-model="form.wantAddress" 
              placeholder="例如：北京市海淀区、上海市浦东新区" 
              prefix-icon="el-icon-location-information"
              clearable
            ></el-input>
          </el-form-item>
        </div>

        <!-- 第二行：期望薪资 -->
        <el-form-item label="期望薪资 (元/月)" prop="wantMoney">
          <el-input 
            v-model="form.wantMoney" 
            placeholder="请输入期望薪资，例如：8000-12000" 
            prefix-icon="el-icon-coin"
          >
            <template slot="append">元</template>
          </el-input>
          <div class="form-tip">建议填写薪资范围，如 10k-15k 或 面议</div>
        </el-form-item>

        <!-- 第三行：已投递简历次数 -->
        <el-form-item label="已投递简历次数" prop="wangtNum">
          <el-input-number 
            v-model="form.wangtNum" 
            :min="0" 
            :max="999" 
            step="1"
            controls-position="right"
            style="width: 100%;"
            placeholder="0"
          ></el-input-number>
          <div class="form-tip">记录您已投递的简历数量，便于后续跟踪</div>
        </el-form-item>

        <!-- 隐藏字段：用于存储当前用户信息 (实际开发中从 Store/Token 获取) -->
        <input type="hidden" v-model="form.userId">
        <input type="hidden" v-model="form.userName">

        <!-- 提交按钮 -->
        <div class="submit-section">
          <el-button 
            type="primary" 
            size="large" 
            @click="submitForm" 
            :loading="loading" 
            class="submit-btn"
            round
          >
            <i class="el-icon-check" v-if="!loading"></i>
            {{ loading ? '保存中...' : '立即保存意向' }}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'JobWishRegister',
  data() {
    // 自定义验证器：薪资格式
    const validateMoney = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入期望薪资'));
      } else {
        // 简单验证是否包含数字
        if (!/\d/.test(value)) {
          callback(new Error('薪资必须包含数字'));
        } else {
          callback();
        }
      }
    };

    return {
      loading: false,
      // 模拟当前登录用户信息 (实际项目中请从 localStorage 或 Vuex 获取)
      currentUser: {
        id: 1001, 
        username: '张三'
      },
      form: {
        userId: '',
        userName: '',
        wantAddress: '',
        wantMoney: '',
        wantGangwei: '',
        wangtNum: 0
      },
      // 表单验证规则
      rules: {
        wantGangwei: [
          { required: true, message: '请输入期望岗位', trigger: 'blur' }
        ],
        wantAddress: [
          { required: true, message: '请输入期望工作地区', trigger: 'blur' }
        ],
        wantMoney: [
          { required: true, validator: validateMoney, trigger: 'blur' }
        ],
        wangtNum: [
          { required: true, message: '请输入投递次数', trigger: 'change' }
        ]
      }
    };
  },
  created() {
    // 初始化用户信息
    this.initUserInfo();
  },
  methods: {
    initUserInfo() {
      // 在实际项目中，这里应该从登录后的 Token 或全局状态管理获取
      // 这里为了演示，使用模拟数据
      this.form.userId = this.currentUser.id;
      this.form.userName = this.currentUser.username;
      
      console.log(`当前用户: ${this.form.userName} (ID: ${this.form.userId})`);
    },

    submitForm() {
      this.$refs.wishForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          
          // 构造请求数据
          const postData = {
            userId: this.form.userId,
            userName: this.form.userName,
            wantAddress: this.form.wantAddress,
            wantMoney: this.form.wantMoney,
            wantGangwei: this.form.wantGangwei,
            wangtNum: this.form.wangtNum
          };

          // 调用后端接口
          // 接口地址：http://localhost:8090/user/addWantMessage (假设 user 模块，根据你之前的路径推断)
          // 如果路径不同，请修改下面的 URL
          axios.post('http://localhost:8090/user/addWantMessage', postData)
            .then(response => {
              this.loading = false;
              if (response.data && response.data.code === 200) {
                this.$message({
                  message: '求职意向保存成功！祝您早日找到心仪工作',
                  type: 'success',
                  duration: 2000
                });
                
                // 可选：成功后重置表单或跳转
                // this.resetForm();
                setTimeout(() => {
                   // this.$router.push('/dashboard'); // 示例跳转
                }, 1500);
              } else {
                this.$message.error(response.data.msg || '保存失败，请稍后重试');
              }
            })
            .catch(error => {
              this.loading = false;
              console.error('提交错误:', error);
              this.$message.error('网络异常，保存失败');
            });
        } else {
          this.$message.warning('请填写完整且正确的信息');
          return false;
        }
      });
    },

    resetForm() {
      this.$refs.wishForm.resetFields();
      this.form.wangtNum = 0;
      // 重新赋值用户信息，防止 resetFields 清空隐藏字段
      this.initUserInfo();
    }
  }
};
</script>

<style scoped>
/* 整体背景 */
.job-wish-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  font-family: "Noto Sans", system-ui, sans-serif;
}

/* 卡片容器 */
.card-wrapper {
  background: #ffffff;
  width: 100%;
  max-width: 600px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  padding: 40px;
  box-sizing: border-box;
  transition: transform 0.3s ease;
}

.card-wrapper:hover {
  transform: translateY(-5px);
}

/* 头部样式 */
.card-header {
  text-align: center;
  margin-bottom: 35px;
}

.icon-box {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 15px;
  box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
}

.icon-box i {
  font-size: 32px;
  color: #fff;
}

.title {
  font-size: 24px;
  color: #303133;
  margin: 0 0 10px;
  font-weight: 600;
}

.subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

/* 表单样式 */
.wish-form {
  width: 100%;
}

.form-row {
  display: flex;
  gap: 20px;
}

.form-row .el-form-item {
  flex: 1;
}

.el-form-item__label {
  font-weight: 500;
  color: #606266;
  font-size: 15px;
  padding-bottom: 8px;
}

.el-input__inner, .el-input-number__inner {
  border-radius: 8px;
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  transition: all 0.3s;
}

.el-input__inner:focus, .el-input-number__inner:focus {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.el-input-group__append {
  background-color: #f5f7fa;
  border-left: none;
  color: #909399;
  font-weight: bold;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  line-height: 1.4;
}

/* 按钮样式 */
.submit-section {
  margin-top: 30px;
  text-align: center;
}

.submit-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
  border: none;
  box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
  transition: all 0.3s;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(64, 158, 255, 0.4);
}

.submit-btn:active {
  transform: translateY(0);
}

/* 响应式适配 */
@media (max-width: 500px) {
  .form-row {
    flex-direction: column;
    gap: 0;
  }
  
  .card-wrapper {
    padding: 25px;
  }
  
  .title {
    font-size: 20px;
  }
}
</style>